<template>
    <div class="charge-warp" v-loading="loading">
        <div class="display-f just-b align-i-c">
            <el-form ref="form" :model="searchForm" inline>
                <el-form-item>
                    <el-date-picker style="width: 360px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="searchForm.date"  :default-time="['00:00:00', '23:59:59']"
                        type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" align="right">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-select style="width: 128px;" v-model="searchForm.type">
                        <el-option v-for="item in chargetype" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- 会员充值需求要求注释 -->
                <!-- <el-form-item>
                    <el-select style="width: 130px;" v-model="searchForm.payWay">
                        <el-option v-for="item in payWayList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item> -->
								<el-form-item>
                  <el-select style="width: 130px;" v-model="searchForm.recipeType" placeholder="处方类型">
                    <el-option
											v-for="item in recipeTypeList"
											:key="item.value"
											:label="item.label"
											:value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input style="width: 120px;" placeholder="开单人" v-model="searchForm.createUserName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input style="width: 120px;" placeholder="收费员" v-model="searchForm.payee"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="患者姓名/手机号码" v-model="searchForm.searchValue"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input style="width: 120px;" placeholder="商品名称" v-model="searchForm.productName"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-cascader
                        ref="cascader" 
                        v-model="searchForm.categoryTypes"
                        placeholder="类型"
                        :options="levelOptions"
                        :props="{ multiple: true, emitPath: false }"
                        collapse-tags
                        :show-all-levels="false"
                        clearable>
                    </el-cascader>
                </el-form-item>
                <el-form-item>
                    <custom-button type="primary" @click="handleSearch">查询</custom-button>
                    <custom-button type="" @click="handleReset">重置</custom-button>
                </el-form-item>
            </el-form>
            <custom-button size="medium" type="primary" plain @click="handleExport">导出</custom-button>
        </div>
        <div class="table-warp">
            <customTable height="600" :cell-style="{ borderColor: '#DDDDDD' }" @pageChange="pageChange" tooltip-effect="dark" :tableData="tableData" :column="column"
                :total="total" :currentPage="searchForm.pageNum" :currentPageSize="searchForm.pageSize" :header-cell-style="{ background: '#F0F1F3', borderColor: '#DDDDDD' }" border>
                <template slot="discount">
                    <div>
                        <span>议价 </span>
                        <el-tooltip class="item" effect="dark" content="加价展示正数，减价展示负数" placement="top-start">
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                </template>
                <div slot="other" class="total-tips">总收入：<span class="color1F23 fwb">¥{{ statisticsObj.income || 0
                }}</span>，收费：<span class="color1F23 fwb">¥{{ statisticsObj.payPrice || 0 }}</span>，退费：<span
                        class="color1F23 fwb">¥{{ statisticsObj.refundPrice || 0 }}</span>
                </div>
            </customTable>
        </div>
    </div>
</template>
  
<script>
import customTable from '@/components/customTable/customTable'
import { statementDTO, CommonDTO } from '@/DTO/index'
import { Common } from '@/views/Backstage/MedicalData/DTO/common'
import { Utils } from '@/utils/utils'
import moment from 'moment';
import { isMoreThanOneYear, debounce } from '@/utils/validateBase'
import { isNull } from '../../../../utils/validateBase'
export default {
    // 定义引入的组件
    components: { customTable },
    props: {},
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今日',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment())), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '昨日',
                    onClick(picker) {
                        let yesterday = moment().subtract(1, 'days')
                        const end = Utils.timeFormat(Number(Utils.endOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(yesterday)), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '本周',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('isoWeek'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本月',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('month'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                {
                    text: '本年',
                    onClick(picker) {
                        const end = Utils.timeFormat(Number(Utils.endOfDay(moment().endOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        const start = Utils.timeFormat(Number(Utils.startOfDay(moment().startOf('year'))), 'yyyy-MM-DD HH:mm:ss')
                        picker.$emit('pick', [start, end]);
                    }
                },
                ]
            },
            //类型列表
            chargetype: [
                { label: '全部类型', value: '' },
                { label: '收费', value: '1' },
                { label: '退费', value: '2' }
            ],
						recipeTypeList: [
							{ label: '普通处方', value: '1' },
              { label: '理疗处方', value: '2' },
              { label: '医联处方', value: '3' },
              { label: '中成药处方', value: '15' },
              { label: '非处方', value: '4' },
						],
            levelOptions: [],
            searchForm: {
                date: [],
                type: '',
                payWay: '',
								recipeType: '',
                createUserName: '',
                payee: '',
                searchValue: '',
                productName: '',
								categoryTypes: [],
                pageNum: 1,
                pageSize: 20
            },//搜索条件
            tableData: [],//表格数据
            total: 0,//总数
            column: [
                { label: "日期", prop: "createTime", width: 153, align: 'left' },
                { label: "患者", prop: "patientName", width: 80, align: 'left', showOverflowTooltip: true },
                {
                    label: "性别", prop: "sex", width: 60, align: 'left', formatter: (row => {
                        return row.sex == '1' ? '女' : '男'
                    })
                },
                { label: "年龄", prop: "age", width: 60, align: 'left' },
                { label: "手机号", prop: "phone", width: 110, align: 'left' },
                { label: "类型", prop: "type", width: 60, align: 'left' },
                { label: "处方类型", prop: "type", width: 100, align: 'left',formatter:(row=>{
                  if (row.recipeType == '1' && row.isYlcp=='0'){
                    return '普通处方'
                    } else if (row.recipeType == '1' && row.isYlcp == '1'){
                        return '医联产品'
                    } else if (row.recipeType == '2'){
                        return '理疗处方'
                    } else if (row.recipeType == '4'){
                        return '非处方'
                    }else if (row.recipeType == '15'){
                        return '中成药处方'
                    }
                 }) },
                { label: "一级类型", prop: "firstCategoryName", width: 100, align: 'left', showOverflowTooltip: true },
				        { label: "二级类型", prop: "secondCategoryName", width: 100, align: 'left', showOverflowTooltip: true },
                { label: "提成分类属性", prop: "commissionCategoryName", width: 120, align: 'left' },
                { label: "货号", prop: "atrNo", width: 100, align: 'left', showOverflowTooltip: true },
                { label: "商品名称", prop: "productName", width: 180, align: 'left', showOverflowTooltip: true },
                { label: "规格", prop: "specifications", width: 120, align: 'left', showOverflowTooltip: true },
                { label: "数量", prop: "quantity", width: 60, align: 'left', showOverflowTooltip: true },
                { label: "单位", prop: "unit", width: 60, align: 'left', showOverflowTooltip: true },
                { label: "单价", prop: "price", width: 88, align: 'right', showOverflowTooltip: true },
                { label: "合计原价", prop: "totalPrice", width: 91, align: 'right' },
                { label: "议价", prop: "discount", width: 91, align: 'right', slotHeader: 'discount' },
                { label: "优惠券", prop: "couponDiscount", width: 91, align: 'right' },
                { label: "至尊卡", prop: "vipCardDiscount", width: 91, align: 'right' },
                { label: "美团商家优惠", prop: "merchantDiscountAmount", width: 110, align: 'right' },
                { label: "实收", prop: "amount", width: 91, align: 'right' },
                // { label: "支付方式", prop: "payWay", width: 82, align: 'left' },
                { label: "开单人", prop: "createUserName", width: 80, align: 'left', showOverflowTooltip: true },
                { label: "收费员", prop: "payee", width: 80, align: 'left', showOverflowTooltip: true },
                { label: "门诊单号", prop: "orderNumber", width: 153, align: 'left', showOverflowTooltip: true },
                { label: "收费单号", prop: "orderCombinedNum", width: 153, align: 'left', showOverflowTooltip: true },
            ],//表头
            payWayList: [],//支付方式列表   
            statisticsObj: {},//统计对象
            loading: false, // 全局loading
        }
    },
    //变量监听
    watch: {},
    // 页面初始化
    async created() {
			let time = CommonDTO.getSystemTimeDTO()
			let startOfDay = Number(Utils.startOfDay(time))
			let endOfDay = Number(Utils.endOfDay(time))
			this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
			this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
			let payWay = await CommonDTO.getPayWay()
			this.payWayList = [
				{ label: '全部支付方式', value: '' },
				...payWay
			]
			this.getGoodLevel()
			this.getData()
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        //获取分类列表
    async getGoodLevel() {
      let res = await CommonDTO.getDictTypeTreeDTO('level')
      if (res.code == 200) {
        let data = Common.deleteEmptyChildren(res.data)
        this.levelOptions = data
      }
    },
		/**
		 * 导出
		 */
		handleExport: debounce(function () {
			this.searchForm.startTime = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
			this.searchForm.stopTime = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
      this.loading = true
			statementDTO.exportOrderDetail(this.searchForm, { name: '收费明细' }).then(res => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
		}, 1000, true),
		/**
		 * 页码改变
		 */
		pageChange(obj) {
			let { current, size } = obj
			this.searchForm.pageNum = current
			this.searchForm.pageSize = size
			this.queryOrderDetailDoc()
		},
		/**
		 * 重置
		 */
		handleReset() {
			this.searchForm = {
				date: [],
				type: '',
				payWay: '',
				createUserName: '',
				payee: '',
				productName: '',
				searchValue: '',
				pageNum: 1,
				pageSize: 20
			}
			let time = CommonDTO.getSystemTimeDTO()
			let startOfDay = Number(Utils.startOfDay(this.$moment(time)))
			let endOfDay = Number(Utils.endOfDay(this.$moment(time)))
			this.searchForm.date[0] = Utils.timeFormat(startOfDay, 'yyyy-MM-DD HH:mm:ss')
			this.searchForm.date[1] = Utils.timeFormat(endOfDay, 'yyyy-MM-DD HH:mm:ss')
			this.getData()
		},

		/**
		 * 搜索
		 */
		handleSearch() {
			if(_.isEmpty(this.searchForm.date)){
				this.$message.error('请选择时间')
				return
			}
			this.searchForm.pageNum = 1
            let flag = this.searchForm.date&&isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 366)
            if (flag) return this.$message.error('时间范围不能超过一年')
            // let HH = this.$moment().get('hour')
            // let flagOneDay = isMoreThanOneYear(this.searchForm.date[0], this.searchForm.date[1], 1)
            // if(flagOneDay && HH < 22 && HH > 7 ) return this.$message.error('当前选择的日期范围大于1天，请22:00后查询')
			this.getData()
		},
		/**
		 * 获取分页、统计数据
		 */
		async getData() {
			this.searchForm.startTime = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[0], 'yyyy-MM-DD HH:mm:ss')
			this.searchForm.stopTime = this.searchForm.date&&Utils.timeFormat(this.searchForm.date[1], 'yyyy-MM-DD HH:mm:ss')
      this.loading = true
			await this.queryOrderDetailDoc()
			await this.geOrderDetailNum()
      this.loading = false
		},

		/**
		 * 明细单据
		 */
		async queryOrderDetailDoc() {
			let { code, rows, total } = await statementDTO.queryOrderDetailDoc(this.searchForm)
			if (code == 200) {
				this.tableData = rows
				this.total = total
			}
		},
		/**
		 * 查询明细统计
		 */
		async geOrderDetailNum() {
			let { code, data } = await statementDTO.geOrderDetailNum(this.searchForm)
			if (code == 200) {
				this.statisticsObj = isNull(data) ? {} : data
			}
		}
  }
}
</script>
<style lang="less" scoped>
.charge-warp {
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;

	.el-form-item {
		margin-bottom: 0;
	}

	.table-warp {
		margin-top: 16px;
		flex: 1;

		/deep/.el-table {
			border-color: #DDDDDD;
		}

		/deep/.pagination-wrap {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-left: 0;

			.total-tips {
				color: #667182;
				font-size: 14px;
			}
		}
	}
}</style>